import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { FieldConfig } from '../../../_models/field.interface';
@Component({
  selector: 'app-select',
  template: `
    <mat-form-field
      class="demo-full-width margin-top"
      [formGroup]="group"
      [ngStyle]="field.styleDivPrincipal ? field.styleDivPrincipal() : null"
    >
      <mat-select
        [placeholder]="field.label"
        [formControlName]="field.name"
        [ngStyle]="field.style()"
        [(value)]="field.value"
        (selectionChange)="field.change ? field.change($event) : null"
      >
        <mat-option *ngFor="let item of field.options" [value]="item">{{
          item
        }}</mat-option>
      </mat-select>
      <ng-container
        *ngFor="let validation of field.validations"
        ngProjectAs="mat-error"
      >
        <mat-error
          class="cs_input-error"
          *ngIf="group.get(field.name).hasError(validation.name)"
          >{{ validation.message }}</mat-error
        >
      </ng-container>
    </mat-form-field>
  `,
  styles: [],
})
export class SelectComponent implements OnInit {
  field: FieldConfig;
  group: UntypedFormGroup;
  constructor() {}
  ngOnInit() {}
}
